<!--
 SuggestList Component
 The component that contains a list of suggest terms
 devs@droxit.de
 Copyright (c) 2020 droxIT GmbH
-->

<template>
  <b-container fluid="md">
    <b-row>
      <b-col v-if="suggests.length > 0">
        <b-list-group id="rocketsearch-suggest-list">
          <b-list-group-item class="rocketsearch-suggest-item rocketsearch-clickable-container" v-for="suggest in suggests"
                             :key="suggest" v-on:click="use_suggest(suggest)">
            {{ suggest }}
          </b-list-group-item>
        </b-list-group>
      </b-col>
      <b-col v-else class="rocketsearch-no-results" style="padding-left: 10px; padding-right: 10px;">
        <span>
          {{$t('no_suggests')}}
        </span>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  export default {
    name: 'SuggestList',
    props: {
      suggests: Array
    },
    methods: {
      use_suggest: function (suggest) {
        this.$root.$emit('RocketSuggestClickedEvent', suggest);
      }
    }
  }
</script>